import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux';
import store from './store';
import App from './App'
import reportWebVitals from './reportWebVitals'
import './scss/overall.scss'
//import getQueryParamByKey from './helper/getQueryParamByKey'

/*const webinar_live_link: string|null = getQueryParamByKey('wj_lead_unique_link_live_room')
if (webinar_live_link) {
    window.location.href = webinar_live_link;
    // @ts-ignore
    window.fbq("trackCustom", "Registered to a Webinar");
}*/

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <App/>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
)



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
